import React, { createContext, useContext, useState } from "react";
interface FilteredPropertiesContextProps {
  children: any;
}

const FilteredPropertiesContext = createContext({});

export const useFilteredPropertiesContext: any = () => {
  const context = useContext(FilteredPropertiesContext);
  if (!context) {
    throw new Error("Something went wrong");
  }
  return context;
};

export const FilteredPropertiesContextProvider: React.FC<
  FilteredPropertiesContextProps
> = ({ children }) => {
  const [properties, setProperties] = useState<any[]>([]);
  const [maxPageNr, setMaxPageNr] = useState<number>(0);
  const [scrollHeight, setScrollHeight] = useState<number>(0);

  const value: any = {
    properties,
    setProperties,
    maxPageNr,
    setMaxPageNr,
    scrollHeight,
    setScrollHeight,
  };

  return (
    <FilteredPropertiesContext.Provider value={value}>
      {children}
    </FilteredPropertiesContext.Provider>
  );
};
